export default {
  methods: {
    sortObjectByProperty(objArray, prop, direction) {
      if (arguments.length < 2) throw new Error('ARRAY, AND OBJECT PROPERTY MINIMUM ARGUMENTS, OPTIONAL DIRECTION');
      if (!Array.isArray(objArray)) throw new Error('FIRST ARGUMENT NOT AN ARRAY');
      const clone = objArray.slice(0);
      const direct = arguments.length > 2 ? arguments[2] : 1 // Default to ascending;
      const propPath = (prop.constructor === Array) ? prop : prop.split('.');

      clone.sort(function (a, b) {
        for (let p in propPath) {
          const valA = a[propPath[p]];
          const valB = b[propPath[p]];
    
          // convert numeric strings to numbers
          const A = valA ? (isNaN(valA) ? valA : +valA) : ' ';
          const B = valB ? (isNaN(valB) ? valB : +valB) : ' ';
    
          if (A > B) return 1 * direct;
          if (A < B) return -1 * direct;
        }
      });
      return clone;
    },

    subTotal(timecards = null) {
      if (!timecards) timecards = this.unapprovedTimecards;

      return timecards.reduce((total, tc) => {
        return total + parseFloat(tc.total_pay)
      }, 0);
    },

    truncateSentence(string, numWords = 1) {
      if (!string || typeof string !== 'string') return '';
      return string.split(" ").splice(0, numWords).join(" ");
    },

    upperFirstCharacter(string) {
      if (!string || typeof string !== 'string') return '';
      return string.charAt(0).toUpperCase() + string.slice(1)
    },

    isJson(string) {
        try {
            JSON.parse(string);
        } catch (e) {
            return false;
        }
        
        if (typeof JSON.parse(string) === 'object') {
            return true;
        } else {
            return false;
        }
    },
    isMobile() {
      if (/Android|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) return true;
      return false;
    },
  } 
}
